import React, { Component, useCallback, useRef } from 'react';
import visitingprogram from '../../../services/visitingprogram';
import captchaService from '../../../services/captcha';
import { Button, Input, Screen, Text, SubHeader } from '../../../components';
import { maskPhone } from '../../../utils/helpers';
import ReCAPTCHA from 'react-google-recaptcha';

import PropTypes from 'prop-types';
import {
  ContactContainer,
  ColStyled,
  ButtonContainer,
  Textsbody,
  Textslist,
  RowStyled,
  H2Typography,
  Programsimg,
} from './styles';

import banner from '../../../assets/imgs/banner-desktop-visiting-program.webp';
import bannerMobile from '../../../assets/imgs/banner-mobile-visiting-program.webp';
import portas from '../../../assets/logos/logo-portas-abertas.png';

const {
  defaultStates,
  defaultAlertScreenOnClick,
  defaultModalOnHide,
} = require('../../../utils/defaults');

class VisitingProgram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: {
        name: '',
        email: '',
        phone: '',
        participants: '',
        cooperative: '',
        message: '',
      },
      labelButton: 'Enviar',
      success: false,
      error: false,
      recaptcha: false,
      ...defaultStates(),
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.modalOnHide = this.modalOnHide.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.header = this.header.bind(this);
    this.body = this.body.bind(this);
  }

  modalOnHide = () => {
    defaultModalOnHide(this);
  };

  alertScreenOnClick = () => {
    defaultAlertScreenOnClick(this);
  };

  handleSubmit = async () => {
    this.setState({ loadingState: true });
    const { contact } = this.state;
    const { recaptcha } = this.state;
    let labelButton = '';
    let success = false;
    let error = false;

    if (recaptcha) {
      const response = await visitingprogram.save(contact);
      if (response.ok) {
        const alertScreenState = {
          title: 'Mensagem enviada com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/programa-de-visita',
        };
        labelButton = 'Enviada!';
        success = true;

        this.setState({ alertScreenState, labelButton, success, error });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        labelButton = 'Erro';
        error = true;

        this.setState({ modalState, labelButton, success, error });
      }
    } else {
      const modalState = {
        title: 'Erro',
        text: 'reCAPTCHA não foi verificado!',
        toggle: true,
        onHide: this.modalOnHide,
      };
      labelButton = 'Erro';
      error = true;
      this.setState({ modalState, labelButton, success, error });
    }
    this.setState({ loadingState: false });
  };

  handleChange = (field, event) => {
    const { contact } = this.state;

    const value = event.target
      ? field === 'phone'
        ? maskPhone(event.target.value)
        : event.target.value
      : event;

    contact[field] = value;
    this.setState({ contact });
  };

  handleChangeCaptcha = async (token) => {
    const response = await captchaService.checkCaptcha(token);
    if (response.data.success === true) {
      this.setState({ recaptcha: true });
    } else {
      this.setState({ recaptcha: false });
    }
  };

  header() {
      return (
        <SubHeader
          image
          backgroundImage={banner}
          backgroundImageMobile={bannerMobile}
          minHeightSm={452}
          minHeight={313}
          title={'Programa de Visitas'}
        />
      );
    }

  body = () => {
    const { contact, success, error, labelButton, recaptcha } = this.state;

    return (
      <ContactContainer className={'mb-lg-5 pb-lg-5'}>
        <RowStyled className={'mb-lg-5  d-flex justify-content-center'}>
          <ColStyled lg={6}>
            <Textsbody>
              Quer entender melhor o papel do FGCoop, suas operações e como atuamos para
              proteger os depósitos dos cooperados? <br /><br />
              O programa <b>FGCoop Portas Abertas</b> oferece visitas presenciais à nossa 
              sede em Brasília (DF), proporcionando uma experiência imersiva sobre o funcionamento
              do Fundo e seu papel na solidez do cooperativismo financeiro.
            </Textsbody>
          </ColStyled>
          <Programsimg src={portas}></Programsimg>
        </RowStyled>


        <RowStyled className={'mb-lg-5 '}>
          <H2Typography>Regras</H2Typography>
          
          <Textslist>
              <li>As visitas ocorrem entre 10h e 16h, com duração de até 2 horas.</li>
              <li>Cada grupo pode ter até <b>15 participantes.</b></li>
              <li>A hospedagem e deslocamento até a sede do FGCoop é de responsabilidade dos visitantes</li>
              <li>É permitido tirar fotos durante a visita, exceto em áreas restritas.</li>
          </Textslist>
        </RowStyled>

        <RowStyled className={'mb-lg-5 pb-lg-5 d-flex flex-column align-items-center'}>
          <H2Typography>Preencha o formulário com sua solicitação de visita</H2Typography>
          <ColStyled lg={8} className={'d-flex flex-column justify-content-center mb-4 pb-3 mb-lg-0 pb-lg-0'}>
            <Input
              rounded
              border
              required
              id={'name'}
              value={contact.name}
              placeholder={'NOME'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('name', e);
              }}
              error={error && contact.name === ''}
            />
            <Input
              rounded
              border
              required
              id={'email'}
              type={'email'}
              value={contact.email}
              placeholder={'E-MAIL'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('email', e);
              }}
              error={error && contact.email === ''}
            />
            <Input
              rounded
              border
              required
              id={'phone'}
              value={contact.phone}
              placeholder={'TELEFONE'}
              fontSize={14}
              maxLength={15}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('phone', e);
              }}
              error={error && contact.phone === ''}
            />
            <Input
              rounded
              border
              required
              id={'participants'}
              value={contact.participants}
              placeholder={'QUANTIDADE DE PARTICIPANTES'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('participants', e);
              }}
              error={error && contact.participants === ''}
            />
            <Input
              rounded
              border
              required
              id={'cooperative'}
              value={contact.cooperative}
              placeholder={'COOPERATIVA'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('cooperative', e);
              }}
              error={error && contact.cooperative === ''}
            />
            <Input
              rounded
              border
              required
              textarea
              id={'message'}
              value={contact.message}
              placeholder={'MENSAGEM'}
              fontSize={14}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('message', e);
              }}
              error={error && contact.message === ''}
            />

            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
              onChange={(e) => {
                this.handleChangeCaptcha(e);
              }}
            />

            <ButtonContainer>
              <Button
                greenButton
                width={113}
                widthMobile={150}
                text={labelButton}
                onClick={() => {
                  this.handleSubmit();
                }}
                success={success}
                error={error}
              />
            </ButtonContainer>
          </ColStyled>
        </RowStyled>
      </ContactContainer>
    );
  };

  render = () => {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        header={this.header}
        body={this.body}
        modalState={modalState}
        alertScreenState={alertScreenState}
        loadingState={loadingState}
      />
    );
  };
}

VisitingProgram.propTypes = {
  //props
  history: PropTypes.object,
};
export default VisitingProgram;
